import { PhotoType } from "./photoDataPhotoType";

export class CallPhotoData {
  public blobServiceFileName: string;
  public type: PhotoType
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/callPhotoData.ts